import ScorecardInfoTip from "./ScorecardInfoTip";

/**
 * Top campaigns table — sorted by converted units. Highlights the currently
 * active channel filter badge and colour-codes conversion rate cells.
 */
export default function CampaignTable({ data, filterBadge, embedded = false }) {
  // When `embedded` = true, render *inside* another surface (e.g. inside
  // a `<details>` block) — skip the outer surface wrapper + header so we
  // don't double up on styling.
  const inner = (
    <>
      {!embedded && (
        <div className="mb-3 flex items-start justify-between gap-2">
          <div>
            <h3 className="font-display text-base font-extrabold inline-flex items-center gap-1.5">
              Top Campañas por Conversión
              <ScorecardInfoTip
                label="Top campañas"
                formula="Unidades vendidas atribuidas por leads_digital.campaign, ordenado descendente."
                extra="Cada venta se atribuye a UNA sola campaña (la del primer lead que hizo match) para evitar doble-conteo."
                source="sales ∩ leads_digital.campaign (UTM del pixel · Zapier)"
              />
            </h3>
            <p className="text-[11px] text-gray-500 mt-1">
              Unidades atribuidas por campaña · match compuesto email/nombre/teléfono
            </p>
          </div>
          {filterBadge && (
            <span className="pill text-[10px] font-extrabold uppercase tracking-wider"
              style={{ background: "#f4c400", color: "#111827", padding: "4px 8px" }}
              data-testid="campaigns-filter-badge">
              {filterBadge}
            </span>
          )}
        </div>
      )}
      {embedded && filterBadge && (
        <div className="mb-2 flex justify-end">
          <span className="pill text-[10px] font-extrabold uppercase tracking-wider"
            style={{ background: "#f4c400", color: "#111827", padding: "4px 8px" }}
            data-testid="campaigns-filter-badge">
            {filterBadge}
          </span>
        </div>
      )}
      <div className="overflow-hidden rounded-lg" style={{ border: "1px solid #e2e8f0" }}>
        <table className="w-full text-xs">
          <thead>
            <tr style={{ background: "#0f1218", color: "#f4c400" }}>
              <th className="text-left px-3 py-2 font-extrabold text-[10px] uppercase tracking-wider">Campaña</th>
              <th className="text-left px-3 py-2 font-extrabold text-[10px] uppercase tracking-wider">Canal</th>
              <th className="text-right px-3 py-2 font-extrabold text-[10px] uppercase tracking-wider">Leads</th>
              <th className="text-right px-3 py-2 font-extrabold text-[10px] uppercase tracking-wider">Conv.</th>
              <th className="text-right px-3 py-2 font-extrabold text-[10px] uppercase tracking-wider">%</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center text-gray-400 py-4">
                  {filterBadge ? `Sin campañas para el canal ${filterBadge}` : "Sin datos"}
                </td>
              </tr>
            )}
            {data.map((c, i) => (
              <tr key={i} style={{
                borderTop: "1px solid #f1f5f9",
                background: i % 2 === 0 ? "#ffffff" : "#fafafa",
              }}>
                <td className="px-3 py-2 font-semibold text-gray-900 truncate"
                  style={{ maxWidth: 220 }} title={c.campaign}>
                  {c.campaign}
                </td>
                <td className="px-3 py-2 text-[10px] font-bold text-gray-600 uppercase tracking-wider">
                  {c.channel || "—"}
                </td>
                <td className="px-3 py-2 text-right tabular-nums font-semibold text-gray-600">{c.leads}</td>
                <td className="px-3 py-2 text-right tabular-nums font-extrabold"
                  style={{ color: c.converted > 0 ? "#166534" : "#94a3b8" }}>
                  {c.converted}
                </td>
                <td className="px-3 py-2 text-right tabular-nums font-bold"
                  style={{
                    color: c.conversion_pct >= 3 ? "#166534"
                      : c.conversion_pct >= 1 ? "#854d0e" : "#991b1b",
                  }}>
                  {c.conversion_pct.toFixed(1)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
  return embedded
    ? <div data-testid="campaigns-table">{inner}</div>
    : <div className="surface p-6" data-testid="campaigns-table">{inner}</div>;
}
